export const chunk = ({ items, size }) => {
  return items.reduce((acc, item, index) => {
    const chunkIndex = Math.floor(index / size);
    if (!acc[`${chunkIndex}`]) {
      acc[`${chunkIndex}`] = [];
    }
    acc[`${chunkIndex}`].push(item);
    return acc;
  }, []);
};